// https://developers.google.com/analytics/devguides/collection/gtagjs/events
export default function gaEvent(eventName, parameters) {
  if (window.gtag) {
    window.gtag('event', eventName, parameters)
  } else {
    // eslint-disable-next-line no-console
    console.log(
      'GA Event',
      'category:', parameters.event_category,
      'event:', eventName,
      'label:', parameters.event_label || parameters.name,
      'value:', parameters.value,
      parameters,
    )
  }
}

export function gaPageView(title, path) {
  if (window.gtag && window.ga_id) {
    window.gtag('config', window.ga_id, {
      page_title: title || document.title,
      page_path: path || window.location.pathname,
    })
  } else {
    // eslint-disable-next-line no-console
    console.log(
      'GA PageView',
      'title:', title || document.title,
      'path:', path || window.location.pathname,
    )
  }
}

const submitEventWhitelist = [
  'checkout_progress',
  'begin_checkout',
  'Submit Manual Address',
  'Submit Autocomplete Address',
]

const checkSubmitted = () => {
  if (!window.dataLayer) return false

  let i = window.dataLayer.length - 1
  while (i > -1) {
    if (window.dataLayer[i][0] === 'event' && submitEventWhitelist.indexOf(window.dataLayer[i][0]) > -1) {
      return true
    }
    i -= 1
  }
  return false
}

export const fieldTouchHistory = []
let trackingInitialised = false
export const trackAbandonments = () => {
  // Abort if we have already initialised
  if (trackingInitialised) return

  trackingInitialised = true
  window.addEventListener('beforeunload', () => {
    const hasInteractedWithFields = fieldTouchHistory.length > 0
    if (hasInteractedWithFields && !checkSubmitted()) {
      gaEvent(fieldTouchHistory.join(' > '), {
        event_category: 'Form Abandonment',
        value: fieldTouchHistory.length,
        non_interaction: true,
      })
    }
  })
}



// WEBPACK FOOTER //
// ./utilities/tracking.js